import { upperFirst, startCase } from 'lodash';
import React from 'react';
import { gql, graphql } from 'react-apollo';
import { toast } from 'react-toastify';
import Form from './Form';
import FormNavigation from './formLib/formNavigation';
import getFieldsToIgnore from '../GqlCmsConfigLib/getFieldsToIgnore';
import getCRUDSchemaFromResource from '../GqlCmsConfigLib/getCRUDSchemaFromResource';
import alertFirstGqlMsg from '../alertFirstGqlMsg';
import mergeSplittedFields from '../formLib/mergeSplittedFields';
import undefinedToNull from '../formLib/undefinedToNull';
import transformErrors from '../formLib/transformErrors';
import joinFieldArraysIntoOne from '../formLib/joinFieldArraysIntoOne';

function Create(props) {
  const { resource, mutate, config, history } = props;

  const resourceName = resource.displayName || resource.name;
  const createSchema = getCRUDSchemaFromResource({
    config,
    resource,
    crudType: 'create',
  });
  const sections = getFieldsToIgnore(createSchema.jsonSchema);
  const onSubmit = async ({ formData }) => {
    let input = undefinedToNull(formData);
    sections.forEach(field => delete input[field]);
    delete input.curatorLandingLink;
    input = mergeSplittedFields(input, createSchema.jsonSchema);
    input = joinFieldArraysIntoOne(input, createSchema.jsonSchema);
    try {
      await mutate({ variables: { input } });
      history.push(`/${resourceName}`);
      toast.success('Create Success');
    } catch (e) {
      alertFirstGqlMsg(e);
    }
  };
  const onCancel = () => {
    history.push(`/${resourceName}`);
  };

  return (
    <div className="form-page-wrapper">
      <div className="form-container">
        <h1>Create {startCase(resourceName)}</h1>
        <Form
          jsonSchemaFormExtensions={config.jsonSchemaFormExtensions}
          schema={createSchema.jsonSchema}
          uiSchema={createSchema.uiSchema}
          noHtml5Validate
          onSubmit={onSubmit}
          onCancel={onCancel}
          transformErrors={transformErrors}
        />
      </div>
      {sections && sections.length > 0 && (
        <FormNavigation sections={sections} jsonSchema={createSchema.jsonSchema} />
      )}
    </div>
  );
}

function CreateWithData(props) {
  const { resource } = props;
  const { crudMapping } = resource;
  let Component = Create;
  const CreateQuery = gql`
  mutation ${crudMapping.create}($input: ${upperFirst(`${resource.name}Input`)}!) {
    ${crudMapping.create}(${resource.name} : $input)
  }
  `;
  Component = graphql(CreateQuery)(Component);

  return <Component {...props} />;
}

export default CreateWithData;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/Create.js